import {Injectable} from '@angular/core';
import {HttpHelper} from '../../http-helper';
import {Observable} from 'rxjs';
import {StatusResponse} from '../models/status.model';

@Injectable({providedIn: 'root'})
export class StatusService {

  constructor(private httpHelper: HttpHelper) {
  }

  getStatus(id: string): Observable<StatusResponse> {
    return this.httpHelper.getRequest(`/jira/status/${id}`)
  }
}
